import React from 'react'
import { boolean, shape, string, func } from 'prop-types'

import Button from 'src/common/components/button'
import Icon from 'src/common/components/icon'
import classNames from 'src/common/helpers/class-names'

import { fsl as blk } from './constants'
import './_favs.scss'

const Favourites = (props) => {
  const { productDetails, className, handleFavouriteClick } = props
  const favClass = classNames({
    blk,
    elt: 'favourites-image',
    className: 'co-item__items',
  })
  const {
    isFavourite,
  } = productDetails

  return (
    <div
      className={classNames({
        blk,
        elt: 'favourites-image-container',
        className: className || 'co-item__items',
      })}
      role="presentation"
      data-auto-id="favourites"
    >
      <div className='context-wrapper'>
        <Button
          isIcon
          category="plain"
          clickHandler={handleFavouriteClick}
          className={classNames({ blk, elt: 'favourites-button' })}
        >
          {isFavourite ? (
            <Icon className={favClass} name="heart-filled" color="charcoal" />
            ) : (
              <Icon className={favClass} name="heart-outlined" color="charcoal" />
            )
          }
        </Button>
      </div>
    </div>
  )
}

Favourites.propTypes = {
  productDetails: shape({
    isFavourite: boolean,
  }),
  className: string,
  handleFavouriteClick: func,
}

Favourites.defaultProps = {
  productDetails: {},
  className: '',
  handleFavouriteClick() {},
}

export default Favourites



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/favourites.js